<template>
  <div class="home">
    <carousel
      :data="slides"
      lang="en"
      :class="this.$isPC ? '' : 'sp-carousel'"
      width="530"
      height="120"
    />
    <h1 style="color: rgb(26, 87, 167)">
      呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call
    </h1>
    <campaign-contact v-if="this.$isPC" />
    <sp-campaign-contact v-else />
    <rental v-if="this.$isPC" />
    <sp-rental v-else />
    <sp-phone-contact v-if="!this.$isPC" />
    <choices :showAll="true" />
    <news />
    <div class="columns" style="margin-top: 30px;">
      <label class="selected" style="cursor: default;">
        <h2>
          <div style="font-size: 26px;">お役立ち</div>
          <div style="font-size: 16px;">コラム</div>
        </h2>
      </label>
    </div>
    <div class="industry-scene-column-header for-in-home">
      <link-button
        v-bind:link="`/columns/`"
        v-bind:title="`詳細へ`"
        :style="this.$isPC ? '' : 'float: none;'"
      />
    </div>
    <div class="body">
      <div class="use-scene-block">
        <router-link to="/column/60">
          <div class="use-scene-block-header">
            製造業の人手不足対策｜工場の生産性を高めて対策を進めよう！
          </div>
        </router-link>
        <p>
          製造業の人手不足が深刻化する背景として、少子高齢化や技能継承の停滞、3Kイメージによる若手離れなどが挙げられます。人手不足の原因と改善策、生産性向上に役立つツールを紹介します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/59">
          <div class="use-scene-block-header">
            サービス業の人手不足｜原因・影響・対策について解説
          </div>
        </router-link>
        <p>
          サービス業で人手不足が起きる原因と経営への影響を整理し、採用に頼らず人手不足を改善できる具体策を解説します。少人数運営を支える呼び出しベル・チャイムも紹介します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/58">
          <div class="use-scene-block-header">
            製造業で作業効率を上げるには？効率化が必要な理由も解説
          </div>
        </router-link>
        <p>
          製造業の現場で作業効率が下がる原因と、その改善アイデアを解説します。呼び出し・コールシステムの導入による効率化も紹介するので、製造現場での生産性を向上させましょう。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCarousel from '@chenfengyuan/vue-carousel'
import News from '@/components/modules/News'
import CampaignContact from '@/components/modules/campaign/CampaignContact'
import Rental from '@/components/modules/campaign/Rental'
import SpCampaignContact from '@/components/modules/campaign/SpCampaignContact'
import SpRental from '@/components/modules/campaign/SpRental'
import SpPhoneContact from '@/components/modules/campaign/SpPhoneContact'
import Choices from '@/components/modules/choice/Choices'
import '../../js/modernizr-custom'

Vue.component(VueCarousel.name, VueCarousel)

export default {
  components: {
    News,
    CampaignContact,
    Rental,
    SpCampaignContact,
    SpRental,
    SpPhoneContact,
    Choices,
  },
  title: '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
  meta:
    '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
  canonical:
    '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
  data() {
    return {
      slides: [
        '<div class="carousel-slide slide1"><div class="front-slide front1"></div></div>',
        '<div class="carousel-slide slide2"></div>',
        '<div class="carousel-slide slide3"></div>',
        '<div class="carousel-slide slide4"></div>',
        '<div class="carousel-slide slide5"><div class="front-slide front5"></div></div>',
      ],
    }
  },
  mounted() {
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.id = 'organization-schema'
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '株式会社ビーアッサ',
      alternateName: 'B-ASSA Co., Ltd.',
      url: 'https://b-call.jp/',
      description:
        '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
      founders: [{ '@type': 'Person', name: '浅山 豊樹' }],
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '+81-76-294-4440',
          contactType: 'customer service',
          areaServed: 'JP',
          availableLanguage: ['Japanese'],
        },
      ],
      address: {
        '@type': 'PostalAddress',
        streetAddress: '石川県加賀市山中温泉中田町ハ-101',
      },
    })
    document.head.appendChild(script)
  },
  beforeDestroy() {
    const script = document.getElementById('organization-schema')
    if (script) document.head.removeChild(script)
  },
}
</script>

<style>
.carousel {
  width: 100%;
  max-width: 1400px;
}

.sp-carousel {
  max-height: 200px;
}

.carousel-slide {
  height: 500px;

  background-repeat: no-repeat;
  background-position: 50% 80%;
  background-size: cover;
}

.sp-carousel .carousel-slide {
  max-height: 150px;
}

.carousel-slide .front-slide {
  height: 100%;

  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
}

.sp-carousel .front-slide {
  max-height: 200px;
}

.carousel-slide.slide1 {
  background-image: url('../../assets/scene1.jpg');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide2 {
  background-image: url('../../assets/slide2.png');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide3 {
  background-image: url('../../assets/slide3.png');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide4 {
  background-image: url('../../assets/slide4.png');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide5 {
  background-image: url('../../assets/scene4.jpg');
  width: 100%;
  height: 500px;
}

.front-slide.front1 {
  background-image: url('../../assets/s1.png');
}

.front-slide.front5 {
  background-image: url('../../assets/s5.png');
}

.home .body {
  display: flex;
  justify-content: center;

  max-width: 960px;
  padding: 0 8px;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
}

.home .body .use-scene-block {
  align-self: flex-start;

  margin: 20px 15px;

  text-align: left;

  flex: 1;
}

.home .body .use-scene-block img {
  display: block;

  width: 100%;
  max-width: 420px;
  height: auto;
  margin: 10px auto;

  background-color: #eee;
}

.home .body .use-scene-block p {
  font-size: 12px;
  line-height: 22px;

  margin: 8px 0 0 0;
}

.home .body .use-scene-block .use-scene-block-header {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.5;
  min-height: calc(1.5em * 3);

  padding-left: 10px;

  border-left: 4px solid rgb(45, 183, 68);

  @media only screen and (max-width: 600px) {
    min-height: auto;
  }
}

.columns {
  display: flex;
  justify-content: space-around;

  width: 50%;
  margin: 0 auto 30px;
}

.columns label {
  font-weight: bold;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  width: 120px;
  height: 120px;

  cursor: pointer;
  text-align: center;

  color: white;
  border-radius: 50%;
  background: rgb(35, 145, 235);
}

.columns label.selected {
  background: rgb(26, 87, 167);
}

.industry-scene-column-header {
  font-weight: bold;
  display: flex;
  justify-content: right;
  max-width: 960px;
  width: 100%;
  margin-right: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue